/* ============================================================
   B&M Pintool — product page interactivity (Shopify)
   Wires every [data-pintool] root: SKU-bound size table,
   inch/metric toggle, fitment helper, quantity + line total,
   real Add to Cart via the Shopify AJAX Cart API.

   Live variant data (id, price in cents, availability) is
   rendered by the section into a <script data-pintool-variants>
   JSON blob keyed by SKU. Display metadata (nominal size,
   decimal, unit, popular flag) lives here and is merged by SKU.
   If a SKU has no matching live variant it is rendered
   disabled and a console warning is emitted — never guessed.
   ============================================================ */
(function () {
  'use strict';

  // SKU -> display metadata. SKUs MUST match live B&M variants.
  // dec shown 3-place so the decimal matches the part number (PT-094 → .094, not
  // .0938). Inch values are the canonical B&M part-number decimals; metric
  // decimal-inch references rounded to 3 places to match.
  var DISPLAY = [
    { sku: 'PT-062', unit: 'inch',   nom: '1/16″', dec: '.062″' },
    { sku: 'PT-078', unit: 'inch',   nom: '5/64″', dec: '.078″' },
    { sku: 'PT-094', unit: 'inch',   nom: '3/32″', dec: '.094″' },
    { sku: 'PT-125', unit: 'inch',   nom: '1/8″',  dec: '.125″', popular: true },
    { sku: 'PT-156', unit: 'inch',   nom: '5/32″', dec: '.156″' },
    { sku: 'PT-187', unit: 'inch',   nom: '3/16″', dec: '.187″' },
    { sku: 'PT-250', unit: 'inch',   nom: '1/4″',  dec: '.250″' },
    { sku: 'PT-2MM', unit: 'metric', nom: '2 mm', dec: '.079″' },
    { sku: 'PT-3MM', unit: 'metric', nom: '3 mm', dec: '.118″' },
    { sku: 'PT-4MM', unit: 'metric', nom: '4 mm', dec: '.157″' },
    { sku: 'PT-5MM', unit: 'metric', nom: '5 mm', dec: '.197″' },
    { sku: 'PT-6MM', unit: 'metric', nom: '6 mm', dec: '.236″' }
  ];

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Inbound deep-link: read ?variant=<id> from the URL so a chart link (or any
  // shared link) lands on the requested size instead of always defaulting to PT-125.
  function variantIdFromUrl() {
    try {
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      return m ? parseInt(m[1], 10) : null;
    } catch (e) { return null; }
  }

  function initRoot(root) {
    // ---- bulk pricing (projection only; the real discount is automatic at checkout) ----
    var bulkMin = parseInt(root.getAttribute('data-bulk-min'), 10) || 0;
    var bulkPct = parseFloat(root.getAttribute('data-bulk-pct')) || 0;

    // volume-pricing modal cells (populated per selected variant in render)
    var vpList = root.querySelector('[data-vp-list]');
    var vpDisc = root.querySelector('[data-vp-disc]');

    // ---- merge live variant data (by SKU) with display metadata ----
    var live = {};
    var blob = root.querySelector('[data-pintool-variants]');
    if (blob) {
      try { live = JSON.parse(blob.textContent || '{}'); }
      catch (e) { console.warn('[bm-pintool] could not parse variant JSON', e); }
    }

    var VARIANTS = DISPLAY.map(function (d) {
      var l = live[d.sku];
      if (!l) {
        console.warn('[bm-pintool] no live Shopify variant matched SKU ' + d.sku + ' — rendered as unavailable.');
        return { sku: d.sku, unit: d.unit, nom: d.nom, dec: d.dec, popular: d.popular,
                 id: null, price: null, available: false, missing: true };
      }
      return { sku: d.sku, unit: d.unit, nom: d.nom, dec: d.dec, popular: d.popular,
               id: l.id, price: l.price, available: !!l.available, missing: false };
    });

    function bySku(sku) { for (var i = 0; i < VARIANTS.length; i++) if (VARIANTS[i].sku === sku) return VARIANTS[i]; return null; }
    function firstSellable(unit) {
      var list = VARIANTS.filter(function (v) { return (!unit || v.unit === unit); });
      var ok = list.filter(function (v) { return v.available; })[0];
      return ok || list[0] || VARIANTS[0];
    }

    // default selection: honor an inbound ?variant=<id> (deep-link from the chart
    // or a shared URL) first; otherwise popular & available, else first sellable inch.
    var urlVariantId = variantIdFromUrl();
    var urlMatch = urlVariantId ? VARIANTS.filter(function (v) { return v.id === urlVariantId; })[0] : null;
    var def = urlMatch || VARIANTS.filter(function (v) { return v.popular && v.available; })[0] || firstSellable('inch');
    var state = { sku: def ? def.sku : (VARIANTS[0] && VARIANTS[0].sku), unit: def ? def.unit : 'inch', qty: 1 };

    // ---- build the size table ----
    var tbody = root.querySelector('[data-size-table] tbody');
    if (tbody) {
      tbody.innerHTML = '';
      VARIANTS.forEach(function (v) {
        var tr = document.createElement('tr');
        tr.setAttribute('data-sku', v.sku);
        tr.setAttribute('data-unit', v.unit);
        if (!v.available) tr.classList.add('pt-unavail');
        var sel = v.available
          ? '<button type="button" class="pt-pickbtn">Select</button>'
          : '<span style="font-family:var(--bm-mono);font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:var(--bm-gray-mute)">Out of stock</span>';
        tr.innerHTML =
          '<td class="pt-nom">' + v.nom + (v.popular ? ' · <span style="font-family:var(--bm-mono);font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:var(--bm-blue);font-weight:600">Most ordered</span>' : '') + '</td>' +
          '<td>' + v.dec + '</td>' +
          '<td>' + v.sku + '</td>' +
          '<td style="text-align:right">' + sel + '</td>';
        if (v.available) tr.addEventListener('click', function () { select(v.sku); });
        tbody.appendChild(tr);
      });
    }

    // ---- unit toggle ----
    var unitBtns = root.querySelectorAll('[data-unit-toggle] button');
    Array.prototype.forEach.call(unitBtns, function (btn) {
      btn.addEventListener('click', function () {
        state.unit = btn.getAttribute('data-unit');
        var cur = bySku(state.sku);
        if (!cur || cur.unit !== state.unit) {
          var first = firstSellable(state.unit);
          if (first) state.sku = first.sku;
        }
        render();
      });
    });

    // ---- fitment helper ----
    var fit = root.querySelector('[data-fitment]');
    if (fit) {
      fit.innerHTML = '<option value="">Select your pin size…</option>';
      ['inch', 'metric'].forEach(function (u) {
        var og = document.createElement('optgroup');
        og.label = u === 'inch' ? 'Inch (fractional)' : 'Metric';
        VARIANTS.filter(function (v) { return v.unit === u; }).forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.sku;
          o.textContent = v.nom + '  —  ' + v.dec + ' Ø' + (v.available ? '' : '  (out of stock)');
          og.appendChild(o);
        });
        fit.appendChild(og);
      });
      fit.addEventListener('change', function () {
        if (!fit.value) return;
        var v = bySku(fit.value);
        var res = root.querySelector('[data-fitment-result]');
        if (v) {
          if (v.available) { state.unit = v.unit; select(v.sku); }
          if (res) res.innerHTML = '→ You need the <b>' + v.sku + '</b> (' + v.nom + ') Pintool' + (v.available ? '.' : ' — currently out of stock.');
        }
      });
    }

    // ---- quantity ----
    var qtyInput = root.querySelector('[data-qty-input]');
    var decBtn = root.querySelector('[data-qty-dec]');
    var incBtn = root.querySelector('[data-qty-inc]');
    function setQty(n) { state.qty = Math.max(1, n | 0); render(); }
    if (decBtn) decBtn.addEventListener('click', function () { setQty(state.qty - 1); });
    if (incBtn) incBtn.addEventListener('click', function () { setQty(state.qty + 1); });
    if (qtyInput) qtyInput.addEventListener('input', function () { state.qty = Math.max(1, parseInt(qtyInput.value, 10) || 1); renderTotals(); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-qty-preset]'), function (p) {
      p.addEventListener('click', function () { setQty(parseInt(p.getAttribute('data-qty-preset'), 10)); });
    });

    // ---- buy (Shopify AJAX Cart API) ----
    var form = root.querySelector('[data-cart-form]');
    var buy = root.querySelector('[data-buy]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = bySku(state.sku);
        if (!v || !v.id || !v.available) return;
        var label = buy ? (buy.querySelector('[data-buy-label]') || buy) : null;
        if (buy) buy.disabled = true;

        // Mirror the theme's product form: request the cart sections in the add
        // call (bundled section rendering) so the drawer re-renders in one shot.
        var sectionIds = [];
        Array.prototype.forEach.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
          var id = el.getAttribute('data-section-id');
          if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
        });
        var body = { items: [{ id: v.id, quantity: state.qty }] };
        if (sectionIds.length) { body.sections = sectionIds.join(','); body.sections_url = window.location.pathname; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
        .then(function (r) { if (!r.ok) throw new Error('cart add failed ' + r.status); return r.json(); })
        .then(function (data) {
          if (label) label.textContent = '✓  Added ' + state.qty + ' × ' + v.sku;
          if (buy) buy.classList.add('added');
          // Update the cart-icon badge + re-render the drawer contents.
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { source: 'product-form-component', itemCount: state.qty, sections: data && data.sections } }
          }));
          // Store setting auto_open_cart_drawer is off, so open the native drawer
          // explicitly (showDialog() no-ops if it is already open).
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          clearTimeout(buy && buy._t);
          if (buy) buy._t = setTimeout(function () { buy.classList.remove('added'); buy.disabled = false; render(); }, 2200);
        })
        .catch(function (err) {
          console.error('[bm-pintool] add to cart error', err);
          if (label) label.textContent = 'Could not add — try again';
          if (buy) { buy.disabled = false; buy._t = setTimeout(function () { render(); }, 2200); }
        });
      });
    }

    function select(sku) { var v = bySku(sku); if (!v) return; state.sku = sku; state.unit = v.unit; render(); }

    function renderTotals() {
      var v = bySku(state.sku);
      var price = v && v.price != null ? v.price : 0;
      var total = price * state.qty;
      var bulkApplies = bulkMin > 0 && bulkPct > 0 && state.qty >= bulkMin && price > 0;
      Array.prototype.forEach.call(root.querySelectorAll('[data-line-total]'), function (el) {
        if (!(v && v.price != null)) { el.textContent = ''; return; }
        if (bulkApplies) {
          var dTotal = total * (1 - bulkPct / 100);
          var dEach = price * (1 - bulkPct / 100);
          el.innerHTML = state.qty + ' × ' + money(price) + ' = ' + money(total) +
            '<span class="pt-line-total__bulk">−' + bulkPct + '% at checkout ≈ <b>' + money(dTotal) + '</b> (' + money(dEach) + ' ea)</span>';
        } else {
          el.innerHTML = state.qty + ' × ' + money(price) + ' = <b>' + money(total) + '</b>';
        }
      });
    }

    function render() {
      var v = bySku(state.sku);
      if (!v) return;
      // unit toggle active state
      Array.prototype.forEach.call(unitBtns, function (btn) {
        btn.classList.toggle('on', btn.getAttribute('data-unit') === state.unit);
      });
      // row visibility + active row
      Array.prototype.forEach.call(root.querySelectorAll('[data-size-table] tbody tr'), function (row) {
        var sameUnit = row.getAttribute('data-unit') === state.unit;
        row.style.display = sameUnit ? '' : 'none';
        row.classList.toggle('on', row.getAttribute('data-sku') === state.sku);
      });
      // readouts
      Array.prototype.forEach.call(root.querySelectorAll('[data-disp="sku"]'), function (e) { e.textContent = v.sku; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-disp="nom"]'), function (e) { e.textContent = v.nom; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-disp="dec"]'), function (e) { e.textContent = v.dec + ' Ø'; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-disp="price"]'), function (e) { e.textContent = v.price != null ? money(v.price) : '—'; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-disp="sel"]'), function (e) { e.textContent = v.nom + ' · ' + v.sku; });
      // volume-pricing modal: reflect the selected variant's price
      if (vpList) vpList.textContent = v.price != null ? money(v.price) : '—';
      if (vpDisc) vpDisc.textContent = (v.price != null && bulkPct > 0) ? money(v.price * (1 - bulkPct / 100)) : '—';
      // qty input
      if (qtyInput) qtyInput.value = state.qty;
      // buy button state
      if (buy) {
        var lbl = buy.querySelector('[data-buy-label]');
        if (v.available) { buy.disabled = false; if (lbl) lbl.textContent = 'Add to Cart'; }
        else { buy.disabled = true; if (lbl) lbl.textContent = 'Out of Stock'; }
      }
      renderTotals();
    }

    render();
    initVolumePricing(root);
  }

  // ---- volume-pricing modal (open/close, focus trap, ESC, focus return) ----
  function initVolumePricing(root) {
    var modal = root.querySelector('[data-vp-modal]');
    var openBtn = root.querySelector('[data-vp-open]');
    if (!modal || !openBtn) return;
    var dialog = modal.querySelector('.pt-vp-dialog');
    var closeEls = modal.querySelectorAll('[data-vp-close]');
    var lastFocus = null;

    function focusables() {
      return Array.prototype.slice.call(dialog.querySelectorAll('a[href], button:not([disabled])'));
    }
    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); dialog.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.addEventListener('keydown', onKeydown, true);
      var f = focusables();
      (f[0] || dialog).focus();
    }
    function close() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.removeEventListener('keydown', onKeydown, true);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    openBtn.addEventListener('click', open);
    Array.prototype.forEach.call(closeEls, function (el) { el.addEventListener('click', close); });
  }

  // ---- product-media gallery (isolated; does not touch the cart/variant wiring above) ----
  function initGallery(g) {
    var stage = g.querySelector('[data-pt-stage] .pt-photo__img');
    var thumbs = g.querySelectorAll('[data-pt-thumb]');
    if (!stage || !thumbs.length) return;
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) { stage.removeAttribute('srcset'); stage.removeAttribute('sizes'); stage.src = full; }
        var alt = t.getAttribute('data-alt');
        if (alt != null) stage.alt = alt;
        Array.prototype.forEach.call(thumbs, function (x) { x.classList.remove('on'); });
        t.classList.add('on');
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pintool]'), initRoot);
    Array.prototype.forEach.call(document.querySelectorAll('[data-pt-gallery]'), initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
